// Helper functions and utilities for TradeIdeasTable

export const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const formatPrice = (price) => {
  if (!price) return 'N/A';
  return new Intl.NumberFormat('vi-VN').format(Math.round(price));
};

export const normalizeSectorField = (idea) => {
  return (
    idea.sector ||
    idea.sector_name ||
    idea.sector_code ||
    idea.industry ||
    idea.industry_name ||
    null
  );
};

export const translateSector = (sector, language) => {
  if (!sector) return null;
  if (typeof sector === 'object' && sector.en && sector.vi) {
    return language === 'vi' ? sector.vi : sector.en;
  }
  return sector;
};

export const handleCSVExport = (csvData) => {
  const csvContent = [
    Object.keys(csvData[0]).join(','),
    ...csvData.map((row) => Object.values(row).join(',')),
  ].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `trade-ideas-${new Date().toISOString().split('T')[0]}.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
};
